import "./app.css";
// Importing the theme module fires its store auto-apply once on load,
// reconciling localStorage with the live html.light class.
import "./lib/theme";
import { mount } from "svelte";
import App from "./App.svelte";
import { loadOverrides } from "./lib/runtime";

const target = document.getElementById("app");
if (!target) throw new Error("Missing #app root");

// Mount immediately with static stubs, then layer KV overrides as they arrive.
mount(App, { target });
void loadOverrides();
